<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="370">
    <v-card>
        <v-card-text class="pt-4 subtitle-1">
         
            
           <p color="green">
               Fishcar: {{fishcar.name}}
            </p>
            <p color="green">
               Series #: {{sales.sequence}}
            </p>
            <p color="green">
               Customer: {{customer.firstname}}
            </p>
            <p color="green">
               Kind of Fish: {{sales.name}}
            </p>
            <p color="green">
               Price: {{$money(sales.price)}}
            </p>
            <p color="green">
               Payment: {{sales.payment_type}}
            </p>
             <p color="green">
               Banyera: {{sales.container}}
            </p>
            <v-divider/>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small rounded  @click="emitToParent('cancel')">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  rounded  @click="emitToParent('ok')">Proceed</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    sales: {
        type: Object,
        default: ()=> { return{} }
    },
     fishcar: {
        type: Object,
        default: ()=> { return{} }
    },
    customer: {
        type: Object,
        default: ()=> { return{} }
    },
  },
  methods: {
    emitToParent (action) {
      this.$emit('DialogEvent', action)
    }
  }
}
</script>
